import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const Section = styled.section`
  padding: 96px 0;
  background: var(--nd-black);
`;

const SectionLabel = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin: 0 0 16px;
`;

const SectionTitle = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 36px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  margin: 0 0 48px;
`;

const Rows = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 32px;
  padding: 24px 0;
  border-top: 1px solid var(--nd-border);
  &:last-child { border-bottom: 1px solid var(--nd-border); }
  @media (max-width: 768px) { grid-template-columns: 1fr; gap: 8px; }
`;

const Freq = styled.div`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-display);
`;

const Body = styled.div`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  color: var(--nd-text-primary);
  line-height: 1.5;
`;

const ITEMS = [
  {
    freq: "Daily",
    body: "Slack channel with your team. Async by default — we don't ping you for things that can wait a few hours.",
  },
  {
    freq: "Weekly",
    body: "Standup with the engineering team you're embedded in. Same time, same place. No separate Dioscuro ceremony.",
  },
  {
    freq: "Weekly status",
    body: "One short Friday email: what shipped, what's blocked, what's next. Forwardable to your board.",
  },
  {
    freq: "Monthly",
    body: "Architecture review with the eng lead. We walk through the past month's changes and the next month's plan.",
  },
  {
    freq: "Quarterly",
    body: "FinOps + risk review with finance and security. Receipts, charts, recommended next moves.",
  },
];

const Cadence = () => (
  <Section>
    <Container>
      <SectionLabel>Cadence</SectionLabel>
      <SectionTitle>How often you'll hear from us.</SectionTitle>
      <Rows>
        {ITEMS.map((it) => (
          <Row key={it.freq}>
            <Freq>{it.freq}</Freq>
            <Body>{it.body}</Body>
          </Row>
        ))}
      </Rows>
    </Container>
  </Section>
);
export default Cadence;
